import React, { useMemo, useState } from 'react';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import Helper from '../Helper';
import { APPLICATION_JSON, DEFAULT_IMAGE_140 } from '../../middleware/types';
const SpecialCalendarModal = ({ index, selectedItemSpecial, showDateSpecial, setShowDateSpecial, selectedDateSpecialItem, setSelectedDateSpecialItem, specialAlternateDate, setSpecialAlternateDate,
    shippingOptionCalendarSpecial, setShippingOptionCalendarSpecial, specialNotAvailableMethod, setDetailFlag, shippingSpecialCalendarPrevious,
    currentDateSpecial, currentcommerceItemId, currentSkuId, currentquantity, selectedShipGroupId, backOrdered }) => {
    const validShowDate = (showDateSpecial instanceof Date && !isNaN(showDateSpecial)) ? showDateSpecial : new Date();
    const validSelectedDate = (selectedDateSpecialItem instanceof Date && !isNaN(selectedDateSpecialItem)) ? selectedDateSpecialItem : null;

    const firstDayThisMonth = new Date(validShowDate.getFullYear(), validShowDate.getMonth(), 1);
    const dayOfWeek = firstDayThisMonth.getDay();
    const firstDayNextMonth = new Date(validShowDate.getFullYear(), validShowDate.getMonth() + 1, 1);
    const lastDayThisMonth = new Date(firstDayNextMonth - 1);
    const lastDayOfWeek = lastDayThisMonth.getDay();
    const currentMoment = moment();
    const isCurrentMonth = validShowDate.getFullYear() === currentMoment.year() && validShowDate.getMonth() === currentMoment.month();

    const currentDateFormat = new Date(currentDateSpecial);
    const formattedDateCurrent = moment(currentDateFormat).format('YYYY-MM-DD HH:mm:ss.SSS');
    const selectedDateFormat = new Date(selectedDateSpecialItem);
    const formattedDateSelect = moment(selectedDateFormat).format('MM/DD/YYYY');
    const displayDateLiving = selectedDateFormat ? ` ${moment(selectedDateFormat).format('MMMM DD, YYYY')}` : 'Select a date';
        
    const month = useMemo(() => {
        const days = [];
        for (let d = firstDayThisMonth; d < firstDayNextMonth; d.setDate(d.getDate() + 1)) {
            days.push(new Date(d));
        }
        return days;
    }, [validShowDate]);

    const weekDays = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

    const handleShippingOptionSpecial = (event) => {
        setShippingOptionCalendarSpecial(event.currentTarget.value);
    };

    const onChange = (date) => {
        setSelectedDateSpecialItem(date);
        const formattedDate = moment(date).format('MM/DD/YYYY');
        const unavailableDates = specialNotAvailableMethod.split(' ').map(date => date.trim());
        const isUnavailableDate = unavailableDates.includes(formattedDate);
        if (!isUnavailableDate) {
            setSpecialAlternateDate(formattedDate);
        } else {
            setSpecialAlternateDate('');
            if (shippingOptionCalendarSpecial === '2 Day Air') {
                setShippingOptionCalendarSpecial('Overnight')
            } else {
                setShippingOptionCalendarSpecial(shippingOptionCalendarSpecial)
            }
        }
        setShowDateSpecial(new Date(date));
    };

    const parseDates = (dateString) => {
        if (!dateString) return [];
        return dateString.split(' ').map(date => {
            const parsedDate = moment(date, 'MM/DD/YYYY', true);
            return parsedDate.isValid() ? parsedDate.toDate() : null;
        }).filter(date => date !== null);
    };

    const alternateDates1 = parseDates(selectedItemSpecial?.alternateDates1 ?? '');
    const alternateDates2 = parseDates(selectedItemSpecial?.alternateDates2 ?? '');
    const isDateInList = (date, list) => {
        return list.some(d => d.getTime() === date.getTime());
    };

    async function handleSpecialCalendar(event) {
        event.preventDefault();
        console.log('backOrdered----handleSpecial',backOrdered)
        var actionUrl = "api/rest/cb/checkout/living-calendar-without-groupname";
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({

            selectedShippingMethod: shippingOptionCalendarSpecial === '2 Day Air' ? 'Second Day Air' : shippingOptionCalendarSpecial,
            // currentDate: currentDateSpecial.format("YYYY-MM-DD HH:mm:ss.SSS"),
            currentDate: formattedDateCurrent,
            currentShipMethod: shippingSpecialCalendarPrevious === '2 Day Air' ? 'Second Day Air' : shippingSpecialCalendarPrevious,
            // selectedDate: selectedDateSpecialItemRef.current.format('MM/DD/YYYY'),
            selectedDate: formattedDateSelect,
            currentcommerceItemId: currentcommerceItemId,
            currentSkuId: currentSkuId,
            currentquantity: String(currentquantity),
            selectedShipGroupId: selectedShipGroupId,
            backOrdered: String(backOrdered && backOrdered)
        }))
        if (res.result == "success") {
            var livingModalClose = document.getElementById(`save-special-calendar-success${index}`)
            livingModalClose.click();
        }
        else {
            console.log("errorList-----", res)
        }

        setDetailFlag(true)
    };
    function replaceImage(event) {
        event.target.src = DEFAULT_IMAGE_140;
    }

    return (
        <>
            <div className="modal gx-0 fade c-shopping-list-modal-body" id={`specialItem-calendar${index}`} tabindex="-1" aria-labelledby={`specialItem-calendar${index}`} aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-lg-a">
                    <div className="modal-content">
                        <button type="button" className="btn-close" id={`save-special-calendar-success${index}`} data-bs-dismiss="modal" aria-label="Close"></button>
                        <div className="modal-body">
                            <div className='col-md-12 px-0'>
                                <div className="form-group row px-md-3 py-md-5">
                                    <div className="col-md-7">
                                        <div className="mr-auto title font-weight-bold">
                                            <h1 className="c-account-heading mb-3">
                                                Change Arrival Date for item:
                                            </h1>
                                        </div>
                                        <div className="c-delivery-item">
                                            <span className="c-delivery-img">
                                                <img onError={replaceImage} src={`${selectedItemSpecial?.imagePathForBackOrderLivingItem ? selectedItemSpecial.imagePathForBackOrderLivingItem : ""}`} /></span>
                                            <div className="c-delivery-items">
                                                <p className="c-delivery-item-text">#{selectedItemSpecial?.itemNumberForBackOrderLivingItem ? selectedItemSpecial.itemNumberForBackOrderLivingItem : ""} Qty:{selectedItemSpecial?.quantityForBackOrderLivingItem ?
                                                    selectedItemSpecial.quantityForBackOrderLivingItem : ""}</p>
                                                <p className="c-delivery-item-text">{selectedItemSpecial?.productDescForBackOrderLivingItem ? selectedItemSpecial.productDescForBackOrderLivingItem : ""}</p>
                                            </div>
                                        </div>
                                        <div className="" dangerouslySetInnerHTML={{
                                            __html: selectedItemSpecial?.chkoutUserInfoMsg ? selectedItemSpecial.chkoutUserInfoMsg : ""
                                        }}>
                                        </div>
                                        <form className="mt-4 ml-1">
                                            <h1 className="c-account-heading mb-4">Select shipping method:<p></p>
                                                <div className="row g-4 c-shipping-box-small">
                                                    <label className="col-12 col-md-6" htmlFor='specialCalenterDayAir'>
                                                        <div className={`c-box-shipping ${specialAlternateDate && shippingOptionCalendarSpecial === "2 Day Air" && 'active'}`}>
                                                            {specialAlternateDate ?
                                                                <div className="form-check">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="radio"
                                                                        name="specialCalendarModal"
                                                                        id="specialCalenterDayAir"
                                                                        value="2 Day Air"
                                                                        checked={shippingOptionCalendarSpecial === "2 Day Air"}
                                                                        defaultChecked={shippingOptionCalendarSpecial === "2 Day Air"}
                                                                        onChange={handleShippingOptionSpecial}
                                                                    />
                                                                </div> : ""}
                                                            <div className="c-box-shipping-calendar">
                                                                <div className="c-box-calendar-info">
                                                                    <p>2 Day Air</p>
                                                                    {specialAlternateDate ? "" : <p>(unavailable)</p>}
                                                                </div>
                                                                <div className="container-circle">
                                                                    <div className="circle-tick"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </label>

                                                    <label className="col-12 col-md-6" htmlFor='specialCalendarOvernight'>
                                                        <div className={`c-box-shipping ${shippingOptionCalendarSpecial === "Overnight" && 'active'} `}>
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="specialCalendarModal"
                                                                    id="specialCalendarOvernight"
                                                                    value="Overnight"
                                                                    checked={shippingOptionCalendarSpecial === "Overnight"}
                                                                    defaultChecked={shippingOptionCalendarSpecial === "Overnight"}
                                                                    onChange={handleShippingOptionSpecial}
                                                                />
                                                            </div>
                                                            <div className="c-box-shipping-calendar">
                                                                <div className="c-box-calendar-info">
                                                                    <p>Overnight</p>
                                                                </div>
                                                                <div className="container-circle">
                                                                    <div className="circle-tick"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </label>
                                                </div>
                                            </h1>
                                        </form>
                                    </div>
                                    <div className="col-12 col-md-5 cb-calendar-modal">
                                        <div className="calendar">
                                            <div className="d-flex justify-content-between cb-month-row">
                                                <Button className='cb-month-previous'
                                                    onClick={() => setShowDateSpecial(new Date(validShowDate.getFullYear(), validShowDate.getMonth() - 1, 1))}
                                                    disabled={isCurrentMonth}>
                                                    <span>&lt;</span>
                                                </Button>
                                                <div className='cb-month-cell'>{validShowDate.toLocaleDateString('en-IN', { month: 'long', year: 'numeric' })}</div>
                                                <Button className='cb-month-next' onClick={() => setShowDateSpecial(new Date(validShowDate.getFullYear(), validShowDate.getMonth() + 1, 1))}>
                                                    <span>&gt;</span>
                                                </Button>
                                            </div>
                                            <div className="d-flex justify-content-between">
                                                {weekDays.map((weekDay, index) => (
                                                    <div key={index} className="day cb-weekday">
                                                        <small>{weekDay}</small>
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="d-flex flex-wrap list-days">
                                                {Array.from({ length: dayOfWeek }).map((_, index) => (
                                                    <div key={index} className="day cell_day empty_cell_start" style={{ flex: '0 0 14.28%' }}></div>
                                                ))}
                                                {month.map((day) => {
                                                    const isAlternateDate1 = isDateInList(day, alternateDates1);
                                                    const isAlternateDate2 = isDateInList(day, alternateDates2);
                                                    const highlightSelectedDate =
                                                        validSelectedDate &&
                                                        validSelectedDate.getDate() === day.getDate() &&
                                                        validSelectedDate.getMonth() === day.getMonth() &&
                                                        validSelectedDate.getFullYear() === day.getFullYear();
                                                    const variant = isAlternateDate1 ? 'onchange-dates' : isAlternateDate2 ? 'onchange-dates' : 'disabled-dates';
                                                    const disabled = !isAlternateDate1 && !isAlternateDate2;

                                                    return (
                                                        <div key={day} className="day cell_day cell_of_days">
                                                            <Button
                                                                variant={highlightSelectedDate ? 'highlight-selected-date' : variant}
                                                                onClick={() => onChange(day)}
                                                                className="w-100"
                                                                disabled={disabled}
                                                            >
                                                                {day.getDate()}
                                                            </Button>
                                                        </div>
                                                    );
                                                })}
                                                {Array.from({ length: 6 - lastDayOfWeek }).map((_, index) => (
                                                    <div key={index} className="day cell_day empty_cell_end" style={{ flex: '0 0 14.28%' }}></div>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="mt-5 m-auto text-center fst-italic" style={{ width: '280px' }}>
                                            <span>Selected Date:</span>
                                            <span id="dateDisplay">{displayDateLiving}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 text-center  mt-5 mb-md-5 d-grid m-md-auto">
                                    <button id="saveDate" className="btn btn-primary block" onClick={handleSpecialCalendar}>SAVE DATE</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default SpecialCalendarModal